import { useId } from 'vue'

import type { JWT } from '@/types/Common'
import type { Seller } from '@/types/Seller.ts'

export const parseJwt = (token: string): JWT | null => {
    if (!token) return null

    const splitToken = token.split('.')
    if (splitToken.length !== 3) return null

    const payloadData = token.split('.')[1] ?? ''

    return JSON.parse(atob(payloadData))
}

export const generateRandomId = (prefix = ''): string => {
    prefix = prefix ? `${prefix}-` : ''
    return `${prefix}${useId()}`
}

export const $prettyNumberRounding = (val: number | string, numOfDecimals = 2) => {
    if (!numOfDecimals || numOfDecimals < 2) {
        numOfDecimals = 2
    } else if (numOfDecimals > 6) {
        numOfDecimals = 6
    }

    const numberToAdd = Math.trunc(5000 / Math.pow(10, numOfDecimals - 2))

    const num = Number(Number(val).toFixed(0))
    let numText = ''

    if (num >= 0) {
        numText = (num + numberToAdd).toString().padStart(7, '0')
    } else {
        numText = ((num - numberToAdd) * -1).toString().padStart(7, '0')
        numText = `-${numText}`
    }

    if (numText.slice(-(6 - numOfDecimals)) === '0'.repeat(6 - numOfDecimals)) {
        const lastDigit = numText.charAt(numText.length - (7 - numOfDecimals))
        switch (lastDigit) {
            case '1':
            case '3':
            case '5':
            case '7':
            case '9':
                numText = numText.slice(0, -(7 - numOfDecimals)) + String(Number(lastDigit) - 1) + numText.slice(-(6 - numOfDecimals))
        }
    }

    if (numOfDecimals < 6) {
        return `${numText.slice(0, -6)}.${numText.slice(-6, -6 + numOfDecimals)}`
    } else {
        return `${numText.slice(0, -6)}.${numText.slice(-6)}`
    }
}

export const objectKeys = <T extends object>(obj: T) => {
    return Object.keys(obj) as (keyof T)[]
}

export const getUserNameInitials = (data: Seller | string) => {
    if (typeof data === 'string') {
        const namesSplit = data.split(' ')
        if (namesSplit.length === 1 && namesSplit[0]) return namesSplit[0].charAt(0).toUpperCase()
        else if (namesSplit.length >= 2 && namesSplit[0] && namesSplit[1]) return `${namesSplit[0].charAt(0).toUpperCase()}${namesSplit[1].charAt(0).toUpperCase()}`
        return ''
    }

    const userData = data
    if (!userData.first_name || !userData.last_name) return ''
    return (`${userData.first_name.charAt(0)}${userData.last_name.charAt(0)}`).toUpperCase()
}

export const PRICE_MULTIPLIER = 1_000_000
export const TOTAL_DISCOUNT_PERCENTAGE = 100_000_000
export const nullDate = '0001-01-01'
export const MongoDBNullId = '000000000000000000000000'
export const BaseAttachmentsPath = '/api/sales_portal/v1/attachments'

export const HasCountryPrefix = (taxNumber: string) => {
    return /^[a-zA-Z]{2}/.test(taxNumber)
}

export const formatSize = (bytes: number): string => {
    const units = ['B', 'KB', 'MB', 'GB', 'TB']
    const i = bytes === 0 ? 0 : Math.floor(Math.log(bytes) / Math.log(1024))
    return `${(parseFloat((bytes / Math.pow(1024, i)).toFixed(2))).toString()} ${units[i] || ''}`
}
